export default "__VITE_ASSET__CgOZyyVX__"